import { fetchData } from "../../Helpers";

export const PACK_PRIZE_IDENT = "pack_prize";

export const isPackPrizeMessage = (message) =>
  message?.ident === PACK_PRIZE_IDENT;

export const excludePackPrize = (messages = []) =>
  messages.filter((message) => !isPackPrizeMessage(message));

export const VUSE_TLE_COUPON_IDENT = "vuse_tle_coupon";

export const isVuseTleCouponMessage = (message) =>
  String(message?.ident ?? "").trim() === VUSE_TLE_COUPON_IDENT;

export const isConsumerUltraInsider = (details) =>
  details?.consumer?.ultraInsider === true;

export const filterVisibleMessages = (messages = [], ultraInsider = false) =>
  (Array.isArray(messages) ? messages : []).filter((message) => {
    if (isPackPrizeMessage(message)) {
      return false;
    }

    if (isVuseTleCouponMessage(message)) {
      return ultraInsider === true;
    }

    return true;
  });

export const MESSAGE_STALE_TIME = 1000 * 60 * 1;
export const MESSAGE_REFETCH_INTERVAL = 1000 * 60 * 1;
export const MESSAGE_CACHE_TIME = Infinity;

export function getMessageList() {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/message/list",
    successCallback: () => {},
    payload: {
      limit: 100,
      offset: 0,
      seen: false,
      closed: false,
    },
    controller: controller,
  });
}

export function getMessageListSeen() {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/message/list",
    successCallback: () => {},
    payload: {
      limit: 100,
      offset: 0,
      seen: true,
      closed: false,
    },
    controller: controller,
  });
}

export function setMessageAsSeen(uuid, successCallback) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/message/seen",
    successCallback: successCallback,
    payload: {
      message: {
        uuid,
      },
    },
    controller: controller,
    shouldThrowError: false,
  });
}

export function setMessagesAsSeen(payload, successCallback) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/message/seen-all",
    successCallback: successCallback,
    payload,
    controller: controller,
    shouldThrowError: false,
  });
}

export function setMessagesAsClosed(payload, successCallback) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/message/close-all",
    successCallback: successCallback,
    payload: payload,
    controller: controller,
    shouldThrowError: false,
  });
}
